import { render } from "./Step_10.vue?vue&type=template&id=24a06d1e"
import script from "./Step_10.vue?vue&type=script&lang=js"
export * from "./Step_10.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__